import React from 'react';

import { KeyOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const YahooScmCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const accessTokenDirty = useDirtyMaskedField(form, [ 'credentials', 'access_token' ], isEditing);
  const apiKeyDirty = useDirtyMaskedField(form, [ 'credentials', 'api_key' ], isEditing);
  const codeDirty = useDirtyMaskedField(form, [ 'credentials', 'code' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'access_token']}
            label={t('models.ec_account.platform_settings.yahoo_scm.token')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.yahoo_scm.token_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.yahoo_scm.token_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={accessTokenDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_domain']}
            label={t('models.ec_account.platform_settings.yahoo_scm.key_iv')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.yahoo_scm.key_iv_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.yahoo_scm.key_iv_placeholder')}
              prefix={<LockOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'api_key']}
            label={t('models.ec_account.platform_settings.yahoo_scm.key_value')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.yahoo_scm.key_value_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.yahoo_scm.key_value_placeholder')}
              prefix={<KeyOutlined />}
              visibilityToggle={apiKeyDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'code']}
            label={t('models.ec_account.platform_settings.yahoo_scm.salt_key')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.yahoo_scm.salt_key_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.yahoo_scm.salt_key_placeholder')}
              prefix={<SafetyOutlined />}
              visibilityToggle={codeDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'version']}
            label={t('models.ec_account.platform_settings.yahoo_scm.version')}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.yahoo_scm.version_placeholder')}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default YahooScmCredentials;
